var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-agent-wrapper" }, [
    _c(
      "div",
      { staticClass: "no-agent-icon-wrapper" },
      [_c("icon-no-preferred-agent")],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "no-agent-text" }, [
      _vm._v(_vm._s(_vm.$t("message.noPreferredAgent"))),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "no-agent-button",
        on: {
          click: function ($event) {
            return _vm.openSelectModal()
          },
        },
      },
      [_vm._v(_vm._s(_vm.$t("message.toPrefer")))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }